import React, { useEffect, useState } from 'react';
import { useCitations } from './hooks/useCitations';
import { TextButton } from 'js/design_system/TextButton';
import { Button } from 'js/design_system/Button';
import CitationModal from 'js/journals/CitationModal';

type Props = {
  workId: number;
  source: string;
  buttonClassName?: string;
  asTextButton?: boolean;
  hideLabel?: boolean;
};

export const CitationButton = ({
  workId,
  source,
  buttonClassName,
  asTextButton,
  hideLabel,
}: Props) => {
  const [citationModalOpen, setCitationModalOpen] = useState(false);
  const { citations, loadCitations } = useCitations(workId);

  useEffect(() => {
    loadCitations();
  }, [workId, loadCitations]);

  const openCitationsModal = () => {
    setCitationModalOpen(true);
  };

  const closeCitationsModal = () => {
    setCitationModalOpen(false);
  };

  const ButtonComponent = asTextButton ? TextButton : Button;
  const additionalButtonComponentProps = asTextButton
    ? { inline: true }
    : { secondary: true };

  return (
    <>
      <ButtonComponent
        onClick={openCitationsModal}
        icon="format_quote"
        className={buttonClassName}
        {...additionalButtonComponentProps}
      >
        {!hideLabel && 'Cite'}
      </ButtonComponent>
      <CitationModal
        open={citationModalOpen}
        citations={citations}
        onClose={closeCitationsModal}
        entity_id={workId}
        source={source}
      />
    </>
  );
};
